document.addEventListener("DOMContentLoaded", () => {
  /* ================= SLIDESHOW LOGIC ================= */
  document.querySelectorAll(".custom-slideshow").forEach(slideshow => {
    const track = slideshow.querySelector(".slideshow__track");
    const slides = [...slideshow.querySelectorAll(".slideshow__slide")];
    const dotsContainer = slideshow.querySelector(".slideshow__dots");

    if (!track || slides.length <= 1 || !dotsContainer) return;

    let current = 0;
    let interval = null;
    const autoplay = slideshow.dataset.autoplay === "true";
    const speed = (parseInt(slideshow.dataset.speed) || 5) * 1000;

    // Set CSS duration variable for progress bar
    dotsContainer.style.setProperty("--dot-anim-duration", speed + "ms");

    // Build Dots
    dotsContainer.innerHTML = slides.map((_, i) => `
      <button aria-label="Slide ${i + 1}" class="${i === 0 ? 'active' : ''}">
        <span class="dot-progress"></span>
      </button>
    `).join("");

    const dots = [...dotsContainer.querySelectorAll("button")];

    function update(index) {
      current = (index + slides.length) % slides.length;

      // Move slide
      track.style.transform = `translateX(-${current * 100}%)`;

      dots.forEach((dot, i) => {
        dot.classList.toggle("active", i === current);
        const progress = dot.querySelector(".dot-progress");
        
        if (progress) {
          // Kill the animation and reset width
          progress.style.transition = "none";
          progress.style.width = "0%";
          
          if (i === current && autoplay) {
            // Force reflow to "un-stick" the transition
            void progress.offsetWidth; 
            progress.style.transition = `width ${speed}ms linear`;
            progress.style.width = "100%";
          }
        }
      });
    }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      interval = setInterval(() => update(current + 1), speed);
    }

    function stopAutoplay() {
      clearInterval(interval);
    }

    // Event Listeners
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        stopAutoplay();
        update(i);
        startAutoplay();
      });
    });

    // Swipe Support
    let startX = 0;
    slideshow.addEventListener("touchstart", e => { startX = e.touches[0].clientX; }, { passive: true });
    slideshow.addEventListener("touchend", e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        stopAutoplay();
        update(current + (diff > 0 ? 1 : -1));
        startAutoplay();
      }
    }, { passive: true });

    // Pause on hover
    slideshow.addEventListener("mouseenter", stopAutoplay);
    slideshow.addEventListener("mouseleave", startAutoplay);

    // Init
    update(0);
    startAutoplay();
  });

  /* ================= DESKTOP HOVER CAROUSEL ================= */
  if (window.innerWidth >= 750) {
    document.querySelectorAll(".layout-d-carousel").forEach(carousel => {
      const grid = carousel.querySelector(".shelf-a-carousel-grid, .shelf-c-carousel-grid");
      const inner = carousel.querySelector(".shelf-a-carousel-inner, .shelf-c-carousel-inner");

      if (!grid || !inner) return;

      let targetX = 0;
      let currentX = 0;
      let anim = null;

      const animate = () => {
        currentX += (targetX - currentX) * 0.1; // Smoothness factor
        inner.style.transform = `translate3d(${-currentX}px, 0, 0)`;
        anim = requestAnimationFrame(animate);
      };

      grid.addEventListener("pointermove", e => {
        const rect = grid.getBoundingClientRect();
        const ratio = (e.clientX - rect.left) / rect.width;
        // Ensure ratio stays between 0 and 1
        const clampedRatio = Math.max(0, Math.min(1, ratio));
        targetX = clampedRatio * (inner.scrollWidth - grid.clientWidth);
        if (!anim) animate();
      });

      grid.addEventListener("pointerleave", () => {
        if (anim) {
          cancelAnimationFrame(anim);
          anim = null;
        }
      });
    });
  }
});